import { render, staticRenderFns } from "./OrderEditor.vue?vue&type=template&id=da4a22ca"
import script from "./OrderEditor.vue?vue&type=script&lang=js"
export * from "./OrderEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports